import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { Switch, Box } from "@mui/material";
import Swal from "sweetalert2";
import api from "core/interceptors/api";
import { useNavigate } from "react-router-dom";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import LogoutButton from "layouts/logout";

const AutoVendorApproval = () => {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  /* ================= FETCH SETTING ================= */
  useEffect(() => {
    api
      .get("/vendor_register/admin/auto-approval")
      .then((res) => {
        setEnabled(Boolean(res.data.auto_vendor_approval));
      })
      .catch(() => {
        Swal.fire("Error", "Failed to load auto approval setting", "error");
      })
      .finally(() => setLoading(false));
  }, []);

  /* ================= TOGGLE ================= */
  const handleToggle = async () => {
    try {
      const newValue = !enabled;
      await api.post("/vendor_register/admin/auto-approval", {
        auto_vendor_approval: newValue,
      });
      setEnabled(newValue);

      Swal.fire(
        "Updated",
        `Auto Vendor Approval ${newValue ? "Enabled" : "Disabled"}`,
        "success"
      );
    } catch {
      Swal.fire("Error", "Failed to update setting", "error");
    }
  };

  if (loading) return null;

  return (
    <DashboardLayout>
      {/* LOGOUT */}
      <MDBox display="flex" justifyContent="flex-end">
        <LogoutButton onLogout={() => navigate("/login")} />
      </MDBox>

      <DashboardNavbar />

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              {/* HEADER */}
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
              >
                <MDTypography color="white" variant="h6">
                  Auto Vendor Approval Settings
                </MDTypography>
              </MDBox>

              {/* CONTENT */}
              <MDBox p={4}>
                <Box display="flex" alignItems="center" gap={2}>
                  <Switch
                    checked={enabled}
                    onChange={handleToggle}
                    color="success"
                  />
                  <MDTypography variant="body1">
                    {enabled
                      ? "New vendors are automatically approved (Unverified)"
                      : "Admin approval is required for new vendors"}
                  </MDTypography>
                </Box>

                <MDBox mt={2}>
                  <MDTypography variant="caption" color="text">
                    ⚠️ When enabled, vendors can log in immediately but remain
                    <b> unverified</b> until admin verification.
                  </MDTypography>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};

export default AutoVendorApproval;
